var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"blobContainer",class:_vm.styles,attrs:{"viewBox":"0 0 1000 1000"}},[_c('path',{ref:"blob",staticClass:"fill-current"})])}
var staticRenderFns = []

export { render, staticRenderFns }